import { render } from "./NewsSectionComponent.vue?vue&type=template&id=c32f2eb2&scoped=true"
import script from "./NewsSectionComponent.vue?vue&type=script&lang=js"
export * from "./NewsSectionComponent.vue?vue&type=script&lang=js"

import "./NewsSectionComponent.vue?vue&type=style&index=0&id=c32f2eb2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c32f2eb2"]])

export default __exports__